import apiClient from 'api/client';
import {
  BASE_ENDPOINTS,
  RESOURCES,
  SERVICES,
  VERSIONS
} from 'api/common/constants';

const TRACEABILITY_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.TRACEABILITY,
  VERSIONS.V1,
  RESOURCES.DASHBOARD,
  false
);
export const TraceabilityDashboardApi = {
  procurementCard: ({ startDate, endDate }) => {
    return apiClient.post(`${TRACEABILITY_BASE}/card/procurement`, {
      start_date: startDate,
      end_date: endDate
    });
  },
  transferCard: ({ startDate, endDate }) => {
    return apiClient.post(`${TRACEABILITY_BASE}/card/transfer`, {
      start_date: startDate,
      end_date: endDate
    });
  },
  receptionCard: ({ startDate, endDate }) => {
    return apiClient.post(`${TRACEABILITY_BASE}/card/reception`, {
      start_date: startDate,
      end_date: endDate
    });
  },
  pendingTransferCard: ({ startDate, endDate }) => {
    return apiClient.post(`${TRACEABILITY_BASE}/card/pending_transfer`, {
      start_date: startDate,
      end_date: endDate
    });
  },
  warehousePieChart: ({ startDate, endDate }) => {
    return apiClient.post(
      `${TRACEABILITY_BASE}/chart/pie/warehouse_stock_details`,
      {
        start_date: startDate,
        end_date: endDate
      }
    );
  },
  tracebilityCropBarChart: ({ startDate, endDate }) => {
    return apiClient.post(
      `${TRACEABILITY_BASE}/chart/bar/traceability_crop_count`,
      {
        start_date: startDate,
        end_date: endDate
      }
    );
  },
  procurementMap: ({ startDate, endDate }) => {
    return apiClient.post(
      `${TRACEABILITY_BASE}/chart/map/villagewise_procurement`,
      {
        start_date: startDate,
        end_date: endDate
      }
    );
  }
};
